import { IconProps } from 'src/utils/icon';

const ClockIcon: React.FC<IconProps> = ({ size = 1, fill = '#000' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 19"
  >
    <path
      fill={fill}
      d="M9.5.297A9.202 9.202 0 00.297 9.5 9.202 9.202 0 009.5 18.703 9.201 9.201 0 0018.703 9.5 9.202 9.202 0 009.5.297zm3.432 11.615l-.742.928a.595.595 0 01-.835.093L8.87 11.088a1.484 1.484 0 01-.556-1.16V4.157a.594.594 0 01.593-.593h1.188a.594.594 0 01.594.593V9.5l2.152 1.577a.593.593 0 01.092.835z"
    />
  </svg>
);

export default ClockIcon;
